import actiontypes from "../actiontypes";

const initialState = {
  filterbox_visible: true
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.SHOW_FILTERBOX:
      return {
        ...state,
        filterbox_visible: true
      };
    case actiontypes.HIDE_FILTERBOX:
      return {
        ...state,
        filterbox_visible: false
      };
    default:
      return state;
  }
};

export default filterReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/filters.js
 **/